/**
 * @flow
 * @relayHash dc3504b7ff9b97d937353d8b5bfaea2c
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type VehicleIncidentTypeTable_viewer$ref = any;
export type OrderEnum = "ASC" | "DESC" | "%future added value";
export type VehicleIncidentTypeFieldType = "code" | "createdAt" | "createdBy" | "description" | "id" | "isDisabled" | "name" | "suggestedMileage" | "suggestedMonths" | "updatedAt" | "updatedBy" | "%future added value";
export type VehicleIncidentTypeWhere = {|
  and?: ?$ReadOnlyArray<?VehicleIncidentTypeWhere>,
  or?: ?$ReadOnlyArray<?VehicleIncidentTypeWhere>,
  id?: ?ConditionInputType,
  code?: ?ConditionInputType,
  name?: ?ConditionInputType,
  description?: ?ConditionInputType,
  isDisabled?: ?ConditionInputType,
  suggestedMileage?: ?ConditionInputType,
  suggestedMonths?: ?ConditionInputType,
  createdAt?: ?ConditionInputType,
  updatedAt?: ?ConditionInputType,
  createdBy?: ?ConditionInputType,
  updatedBy?: ?ConditionInputType,
|};
export type ConditionInputType = {|
  eq?: ?string,
  ne?: ?string,
  gt?: ?string,
  gte?: ?string,
  lt?: ?string,
  lte?: ?string,
  is?: ?string,
  not?: ?string,
  in?: ?$ReadOnlyArray<?string>,
  notIn?: ?$ReadOnlyArray<?string>,
  like?: ?string,
  notLike?: ?string,
  iLike?: ?string,
  insub?: ?string,
|};
export type VehicleIncidentTypeTableQueryVariables = {|
  count: number,
  cursor?: ?string,
  orderBy?: ?$ReadOnlyArray<?VehicleIncidentTypeFieldType>,
  order?: ?OrderEnum,
  where?: ?VehicleIncidentTypeWhere,
|};
export type VehicleIncidentTypeTableQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: VehicleIncidentTypeTable_viewer$ref
  |}
|};
export type VehicleIncidentTypeTableQuery = {|
  variables: VehicleIncidentTypeTableQueryVariables,
  response: VehicleIncidentTypeTableQueryResponse,
|};
*/


/*
query VehicleIncidentTypeTableQuery(
  $count: Int!
  $cursor: String
  $orderBy: [VehicleIncidentTypeFieldType] = [code]
  $order: OrderEnum = ASC
  $where: VehicleIncidentTypeWhere
) {
  viewer {
    ...VehicleIncidentTypeTable_viewer_2BlNTl
  }
}

fragment VehicleIncidentTypeTable_viewer_2BlNTl on Viewer {
  vehicleIncidentTypes(first: $count, after: $cursor, orderBy: $orderBy, order: $order, where: $where) {
    edges {
      node {
        id
        code
        name
        suggestedMileage
        suggestedMonths
        isDisabled
        __typename
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "cursor",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "orderBy",
    "type": "[VehicleIncidentTypeFieldType]",
    "defaultValue": [
      "code"
    ]
  },
  {
    "kind": "LocalArgument",
    "name": "order",
    "type": "OrderEnum",
    "defaultValue": "ASC"
  },
  {
    "kind": "LocalArgument",
    "name": "where",
    "type": "VehicleIncidentTypeWhere",
    "defaultValue": null
  }
],
v1 = {
  "kind": "Variable",
  "name": "order",
  "variableName": "order"
},
v2 = {
  "kind": "Variable",
  "name": "orderBy",
  "variableName": "orderBy"
},
v3 = {
  "kind": "Variable",
  "name": "where",
  "variableName": "where"
},
v4 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v1/*: any*/),
  (v2/*: any*/),
  (v3/*: any*/)
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "VehicleIncidentTypeTableQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "VehicleIncidentTypeTable_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "count",
                "variableName": "count"
              },
              {
                "kind": "Variable",
                "name": "cursor",
                "variableName": "cursor"
              },
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "VehicleIncidentTypeTableQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "vehicleIncidentTypes",
            "storageKey": null,
            "args": (v4/*: any*/),
            "concreteType": "VehicleIncidentTypeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "VehicleIncidentTypeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "VehicleIncidentType",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "id",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "code",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "name",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "suggestedMileage",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "suggestedMonths",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isDisabled",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "__typename",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "cursor",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "pageInfo",
                "storageKey": null,
                "args": null,
                "concreteType": "PageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hasNextPage",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "endCursor",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "vehicleIncidentTypes",
            "args": (v4/*: any*/),
            "handle": "connection",
            "key": "VehicleIncidentTypeTable_vehicleIncidentTypes",
            "filters": [
              "orderBy",
              "order",
              "where"
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "VehicleIncidentTypeTableQuery",
    "id": null,
    "text": "query VehicleIncidentTypeTableQuery(\n  $count: Int!\n  $cursor: String\n  $orderBy: [VehicleIncidentTypeFieldType] = [code]\n  $order: OrderEnum = ASC\n  $where: VehicleIncidentTypeWhere\n) {\n  viewer {\n    ...VehicleIncidentTypeTable_viewer_2BlNTl\n  }\n}\n\nfragment VehicleIncidentTypeTable_viewer_2BlNTl on Viewer {\n  vehicleIncidentTypes(first: $count, after: $cursor, orderBy: $orderBy, order: $order, where: $where) {\n    edges {\n      node {\n        id\n        code\n        name\n        suggestedMileage\n        suggestedMonths\n        isDisabled\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '70a648d43e40de7eebe6283b380bb28a';
module.exports = node;
